import { render } from "./user-profile-input.vue?vue&type=template&id=77cd4062&scoped=true"
import script from "./user-profile-input.vue?vue&type=script&lang=js"
export * from "./user-profile-input.vue?vue&type=script&lang=js"

import "./user-profile-input.vue?vue&type=style&index=0&id=77cd4062&scoped=true&lang=css"

import exportComponent from "/Users/qmaura/PANOPTIC/hkust-gz-vitals/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77cd4062"]])

export default __exports__